<template functional>
  <h2
    :class="{'black' : props.blackText}"
    class="title">
    <slot/>
  </h2>
</template>

<script>
  export default {
    props: {
      blackText: {
        type: Boolean,
        default: () => false
      }
    }
  }
</script>